"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputConfirmationContent = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
exports.TagNameInputConfirmationContent = {
    view(collectionCount, oldName, newName) {
        return (0, mithril_1.m)('div', [
            (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.TAG_EXISTS, newName)),
            (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.TAG_MERGE_CONFIRM, { collectionCount, oldName, newName }))
        ]);
    }
};
//# sourceMappingURL=tag.name.input.confirmation.js.map